import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { LocalizedLink } from '@rsc/gatsby-localization-helpers';
import styles from '../styles';
import breakpoints from '../breakpoints';
import ExternalLinkIcon from '../svgs/external-link.svg';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${styles.spacing['spacing-md']} 0;

  @media screen and (min-width: ${breakpoints.md}) {
    flex-direction: row;
    gap: ${styles.spacing['spacing-md']};
  }
`;

const LinkStyles = css`
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.defaultFont};
  text-align: center;
  text-decoration: none;
  border: 1px solid ${({ theme }) => theme.colors.brandPrimary};
  margin: 0 0 ${styles.spacing['spacing-md']} 0;
  font-weight: ${styles.fontWeight.semiBold};
  padding: ${styles.spacing['spacing-sm']};

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.link};

    svg {
      fill: ${({ theme }) => theme.colors.link};
    }
  }
`;

const StyledLink = styled(LocalizedLink)`
  ${LinkStyles};
`;

const StyledAnchor = styled.a`
  ${LinkStyles};

  svg {
    margin-left: ${styles.spacing['spacing-sm']};
  }
`;

const LinkIcon = styled(ExternalLinkIcon)`
  fill: ${({ theme }) => theme.colors.cardText};
  height: 15px;
  width: 15px;
`;

function AdditionalLinks({ links, getInternalLink }) {
  return (
    <Container>
      {links?.length > 0 &&
        links.map(link =>
          link?.internalLink ? (
            <StyledLink
              key={`additional-${link.caption}`}
              to={getInternalLink({ ...link, reference: link.internalLink })}
            >
              {link.caption}
            </StyledLink>
          ) : (
            <StyledAnchor
              key={`external-${link.caption}`}
              href={link.href}
              target={link?.blank ? `_blank` : `_self`}
              rel="noreferrer"
            >
              {link.caption}
              <LinkIcon />
            </StyledAnchor>
          )
        )}
    </Container>
  );
}

AdditionalLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      _type: PropTypes.string,
      href: PropTypes.string,
      blank: PropTypes.bool,
      caption: PropTypes.string,
    })
  ).isRequired,
  getInternalLink: PropTypes.func.isRequired,
};

export default AdditionalLinks;
